import { Component, Input, OnInit } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { Column } from 'exceljs';
import { saveAs } from 'file-saver';
import { QuestionsService } from '../../../services/questions.service';

interface UserStatsRow {
    userId: string;
    name: string;
    answered: number;
    correct: number;
}

@Component({
    selector: 'app-toolbox-quiz-stats',
    templateUrl: './toolbox-quiz-stats.component.html',
    styleUrls: ['./toolbox-quiz-stats.component.scss'],
    standalone: false,
})
export class ToolboxQuizStatsComponent implements OnInit {
    @Input() toolboxId!: number;
    statsData: any;

    dataSource: UserStatsRow[] = [];
    displayedColumns = ['name', 'answered', 'correct'];

    constructor(private quizService: QuestionsService) {}

    ngOnInit(): void {
        this.quizService.getToolboxQuizStats(this.toolboxId).subscribe({
            next: response => {
                this.statsData = response;
                this.prepareTable();
            },
        });
    }

    prepareTable() {
        this.dataSource = [];
        for (const userId of Object.keys(this.statsData || {})) {
            const questions = this.statsData[userId] || {};
            const questionIds = Object.keys(questions);
            let correct = 0;
            for (const questionId of questionIds) {
                const answer = questions[questionId][0];
                if (answer && answer.is_correct) correct++;
            }
            // Pak gebruikersnaam uit eerste antwoord
            let name = '';
            if (questionIds.length > 0) {
                name = questions[questionIds[0]][0]?.user?.name || '';
            }
            this.dataSource.push({
                userId,
                name,
                answered: questionIds.length,
                correct,
            });
        }
    }

    exportStats() {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Statistieken');

        worksheet.addRow(['Gebruiker', 'Aantal beantwoord', 'Aantal goed']);

        this.dataSource.forEach(row => {
            worksheet.addRow([row.name, row.answered, row.correct]);
        });

        worksheet.getRow(1).eachCell(cell => {
            cell.font = { bold: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFBBDEFB' },
            };
            cell.border = {
                bottom: { style: 'thin', color: { argb: 'FF1976D2' } },
            };
        });

        worksheet.columns = [{ width: 30 }, { width: 18 }, { width: 14 }] as Column[];

        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, 'quiz-statistieken.xlsx');
        });
    }
}
